<div class="attributes-group--header">
  <div class="attributes-group--header-container">
    <h3
      class="attributes-group--header-text relation-group--header"
      [textContent]="header"
    ></h3>
  </div>
  @if (firstGroup) {
    <div
      class="attributes-group--header-toggle"
      >
      <button
        #wpRelationGroupByToggler
        id="wp-relation-group-by-toggle"
        type="button"
        class="button -small -transparent -with-icon icon-group-by icon-small hide-when-print"
        (click)="toggleButton()"
        >
        <span [textContent]="togglerText"></span>
      </button>
    </div>
  }
</div>

@if (relatedWorkPackages) {
  <div
    class="relation-container"
    >
    @for (relatedWorkPackage of relatedWorkPackages; track relatedWorkPackage) {
      <wp-relation-row [workPackage]="workPackage"
        [groupByWorkPackageType]="groupByWorkPackageType"
        [relatedWorkPackage]="relatedWorkPackage"
       />
    }
  </div>
}
